import { useAtomValue } from "jotai";
import { ScrollView } from "react-native";

import { VStack } from "@whoosh/design-system/src/components/primitive";

import { VerifyEmailOrPhoneStepStateAtom } from "../atoms/stores";
import { InitialStep } from "./InitialStep/InitialStep";
import { InitialStepFragment_Session$key } from "./InitialStep/__generated__/InitialStepFragment_Session.graphql";
import { VerifyCodeStep } from "./VerifyCodeStep/VerifyCodeStep";

type VerifyEmailOrPhone = {
  fragRef: InitialStepFragment_Session$key;
  reloadQuery: () => void;
  onVerificationComplete?: () => void;
};

export const VerifyEmailOrPhoneNotifications = ({
  fragRef,
  reloadQuery,
  onVerificationComplete,
}: VerifyEmailOrPhone) => {
  return (
    <VStack flex={1}>
      <ScrollView style={{ flex: 1 }}>
        <Content
          fragRef={fragRef}
          reloadQuery={reloadQuery}
          onVerificationComplete={onVerificationComplete}
        />
      </ScrollView>
    </VStack>
  );
};

type ContentProps = {
  fragRef: InitialStepFragment_Session$key;
  reloadQuery: () => void;
  onVerificationComplete?: () => void;
};

export const Content = ({
  fragRef,
  reloadQuery,
  onVerificationComplete,
}: ContentProps) => {
  const stepState = useAtomValue(VerifyEmailOrPhoneStepStateAtom);
  const currentStep = stepState.step;

  switch (currentStep) {
    case "Initial":
      return <InitialStep fragRef={fragRef} />;
    case "VerifyCode":
      return (
        <VerifyCodeStep
          reloadQuery={reloadQuery}
          onVerificationComplete={onVerificationComplete}
        />
      );
    default:
      return null;
  }
};
